import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../services/app.service'
// import { DATA } from '../../models/map/map';

enum MapType {
  POLYLINE,
  MARKERS
}

interface Marker {
  lat: number;
  lng: number;
  label?: string;
}

interface MapConfigInterface {
  mapType: string | MapType;
  markers?: Array<Marker>;
  height?: string;
  width?: string;
  mapping?: {
    source?: string;
    markersKey?: string;
    latKey?: string;
    lngKey?: string;
  };
}

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {

  @Input() config: MapConfigInterface;
  @Input() data: any;

  coordinates: Array<any>;
  mappingSource: string;


  constructor(private appService: AppService) { }

  /**
   * MAP Component
   * @author Abhishek
   * @author Neil
   * @task QLIKTAG-2964
   */
  ngOnInit() {

     console.log('MAP CONFIG', this.config);
     console.log('MAP DATA',this.data);
    // this.data['customGetAPI'] = {"requestStatus":true,"errors":[],"warnings":[],"requestedAt":"2019-04-10T04:04:18.925Z","data":{"tracklog":[{"serialNumber":"10113434301","account":{"_accountId":"77464bc0-4349-11e9-8964-a9880a86f672"},"batchNumber":"37801841","_tracklogId":"e9b29660-5a8b-11e9-879b-f9526fb33ef3","data":{"eventDateTime":"2019-04-03T10:47:47.361Z","disposition":"container_closed","geoLocation":{"lng":78.498988,"lat":17.371969},"businessName":"harrys_shipping_company","businessStep":"shipping","epcList":{"serialNumber":"10113434301","batchNumber":"37801841"}},"status":"activated"},{"serialNumber":"10113434301","account":{"_accountId":"77464bc0-4349-11e9-8964-a9880a86f672"},"batchNumber":"37801841","_tracklogId":"a29ff750-5a8a-11e9-b7bd-47bb9cff590a","data":{"eventDateTime":"2019-04-02T10:47:47.361Z","disposition":"disposed","geoLocation":{"lng":73.9492778,"lat":18.5529518},"businessName":"harrys_shipping_company","businessStep":"replacing","epcList":{"serialNumber":"10113434301","batchNumber":"37801841"}},"status":"activated"},{"serialNumber":"10113434301","account":{"_accountId":"77464bc0-4349-11e9-8964-a9880a86f672"},"batchNumber":"37801841","_tracklogId":"8738a060-5a8b-11e9-ab10-878b2de7ec49","data":{"eventDateTime":"2019-04-03T10:47:47.361Z","disposition":"in_transit","geoLocation":{"lng":77.739067,"lat":12.98759},"businessName":"xyz_warehouse","businessStep":"collecting","epcList":{"serialNumber":"10113434301","batchNumber":"37801841"}},"status":"activated"}]},"total_items":3,"processedAt":"2019-04-10T04:04:19.176Z"}


    this.coordinates = this.config.markers ? this.config.markers : [];

    if(this.config.hasOwnProperty('mapping')){
      let source = this.config.mapping.source;

      this.mappingSource = source ? this.data[source] : null;


      if (this.config.mapping.hasOwnProperty('markersKey')) {

        if (this.config.mapping.markersKey && this.config.mapping.markersKey != '') {

          const markersArrayPath = this.config.mapping.markersKey.split('.');
          let latArrayPath = [];
          let lngArrayPath = [];

          //get latitude
          if (this.config.mapping.hasOwnProperty('latKey')) {

            if (this.config.mapping.latKey && this.config.mapping.latKey != '') {
              latArrayPath = this.config.mapping.latKey.split('.');
            }
          }

          //get longitude
          if (this.config.mapping.hasOwnProperty('lngKey')) {

            if (this.config.mapping.lngKey && this.config.mapping.lngKey != '') {
              lngArrayPath = this.config.mapping.lngKey.split('.');
            }
          }
          // console.log(latArrayPath);
          // console.log(lngArrayPath);
          //get the markers array
          let markersArray = this.appService.findObjectByPath(this.mappingSource, markersArrayPath);
          //console.log(markersArray);
          if (markersArray) {

            this.coordinates = markersArray.reduce((acc, item) => {

              let coordinate = { ...item };



              if (latArrayPath.length > 0) {
                let latitude = this.appService.findObjectByPath(item, latArrayPath);

                //console.log(latitude)
                if (latitude) {
                //if (this.validateCoordinate(latitude)) {
                    coordinate.lat = parseFloat(latitude);
                  //}
                }
              }

              if (lngArrayPath.length > 0) {
                let longitude = this.appService.findObjectByPath(item, lngArrayPath);
                  //console.log(longitude)

                if (longitude) {
                  //if (this.validateCoordinate(longitude)) {
                    coordinate.lng = parseFloat(longitude);
                //  }
                }
              }

              acc.push(coordinate);

              return acc;

            }, []);

            console.log('CO-ORDINATES',this.coordinates);
          }




        }
      }

    }




  }


  /**
   * Method to check: `coordinate` should not be object or array
   * @param value {any}
   * @author Abhishek
   * @task QLIKTAG-2964
   */
  validateCoordinate(coordinate: any) {

    if (coordinate instanceof Object == false && !Array.isArray(coordinate)) {
      return true;
    } else {
      return false;
    }
  }
}
